<template>
  <div id="app">
  <navbar></navbar>

    <section>
    <h2 class="title">NAICS Helper Resources </h2>
    <h2 class="title">Search for Industry </h2>
    <h3 class="">Use Keywords or NAICS Codes to search </h3>
    <h4 class="">Example Keyword: 'Restaurant' </h4>

     <b-field label="Industry Description or NAICS Number">
         <b-autocomplete
             :data="data"
             class="is-expanded"
             placeholder="e.g. Textile"
             field="description"
             :loading="isFetching"
             @typing="getAsyncData"
             @select="option => selected = option">

             <template slot-scope="props">
                 <div class="media">
                     <div class="media-left">
                         <img width="32" :src="'./images/factory.jpg'"/>
                     </div>
                     <div class="media-content">
                         {{ props.option.description }}
                         <br>
                         <small>
                             NAICS Code: {{ props.option.naics }},
                         </small>
                     </div>
                 </div>
             </template>
         </b-autocomplete>
         <p class="control">
         <b-button type="is-primary"  @click="addToCart" expanded>Select</b-button>
</p>
         <p class="control">
</p>
     </b-field>
           <b-table :data="orders" >
           <template scope="props">
                 <b-table-column field="naics" label="NAICS">

                  <p>
                 NAICS: {{props.row.naics}}
                 </p>
                 <p>
                Short Description: {{props.row.description}}
                </p>
                <p>
                Detailed Description: Establishments engaged in growing apples in combination with tree nut(s) with the apples or family of tree nuts not accounting
                for one-half of the establishment's agricultural production (i.e., value of crops for market) are classified in U.S. Industry 111336, Fruit and Tree Nut
                Combination Farming.
               </p>

                 </b-table-column>

               </template>


           </b-table>
     </section>
     <section>
     <h2 class="title">Downloads (Excel/CSV) </h2>

  <p>
     <a href="../assets/datasets/2017_NAICS_Structure.xlsx" download> NAICS Structure 2017</a>
     </p>
     <p>
        <a href="../assets/datasets/2017_NAICS_Structure_Summary_Table.xlsx" download> NAICS Summary Table 2017</a>
        </p>
     </section>


  </div>
</template>

<script>
import Navbar from "./features/Navbar"
import 'buefy/dist/buefy.css'
import debounce from 'lodash/debounce'
import axios from 'axios'
 import PayPal from 'vue-paypal-checkout'
 import { mapGetters , mapState} from "vuex";
  export default {
  components: {
  PayPal,
  Navbar
},
      data() {
          return {
            orders: [],
              data: [],
              thetotal: "10",
              myItems: [
  {
    "name": "hat",
    "description": "Brown hat.",
    "quantity": "1",
    "price": "5",
    "currency": "USD"
    },
    {
    "name": "handbag",
    "description": "Black handbag.",
    "quantity": "1",
    "price": "5",
    "currency": "USD"

    }
],
              selected: null,
              isFetching: false,
              credentials: {
  sandbox: 'ARK1S926MJ-vd2UJD1gp3gLGrOAO6LRlxJ8Z8AKEOmD30hptzI1JETpBbm2j_oPrhMHRBl7IMdYUGM_9',
  production: ''
}
          }
      },
          computed: {
  ...mapState({
  authToken: state => state.auth.token ,
})
},
      methods: {
      payment_completed_cb(res){
    console.log("Thank you! We'll send you a confirmation email soon with your invoice. ");
    console.log(res);
},
payment_authorized_cb(res){
    console.log(res);
},
payment_cancelled_cb(res){
    console.log("The payment process has been canceled. No money was taken from your account.");
    console.log(res);
},
          // You have to install and import debounce to use it,
          // it's not mandatory though.
          deleteItem(naics) {
          this.orders = this.orders .filter(function( obj ) {
                return obj.naics !== naics;
              });
          console.log("Deleting NAICS="+naics)
    },
    addToCartDirect: function(description,naics) {
      // console.log("click me")
      var element = this.$refs['thecart'];
    var top = element.offsetTop;
    window.scrollTo(0, top);

      var order = {naics: naics, description: description, price: "$24.99" }
      this.orders.push(order)
    },
          addToCart: function() {
            // console.log("click me")
            var order = {naics: this.selected.naics, description: this.selected.description, price: "$24.99" }
            this.orders.push(order)
          },
          checkoutNow: function() {
             console.log("Check Out")
             router.push({ name: "About" });

          },

                    getAsyncData: debounce(function (name) {
          //  console.log(name)
              if (!name.length) {
                  this.data = []
                  return
              }
              this.isFetching = true
                const options = {
   //   headers: {'X-API': authToken}
    };
              var URI = this.$api.REST_API + '/api/NAICS/' + name
              // var URI = `http://api.normsandratios.com/NAICS/${name}`
              axios.get(URI,options)
                  .then(({ data }) => {
                    // console.log(data)
                      this.data = []
                      // data.results.forEach((item) => this.data.push(item))
                      for (var i = 0, len = data.NAICS.length; i < len; i++) {
                          var element = data.NAICS[i]
              //            console.log(element)
                          var hit = {naics: element.naics, description: element.description }
                //          console.log(hit)
                        this.data.push(hit)
                        }
                      /*
                      data.results.forEach(function(element){
                          console.log(element)
                          var hit = {naics: element.release_date, description: element.title }
                          console.log(hit)
                        this.data.push(hit)
                        })
                        */
                  })
                  .catch((error) => {
                      this.data = []
                      throw error
                  })
                  .finally(() => {
                      this.isFetching = false
                  })
          }, 500)
      }
  }
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/ToolsNAICS.vue